var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNorthPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 190,
    viewBox: "0 -20 118 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.9586,
    cy: 75,
    r: 57.4586,
    stroke: "#CC694C",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.35 55H74.8V90H69.45L50.15 66.3V90H43.7V55H49.05L68.35 78.7V55Z",
    fill: "#CC694C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 -15 L70 10 H48 L58 -15Z",
    fill: "#CC694C",
    stroke: "#CC694C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorthPointer);
export default __webpack_public_path__ + "static/media/north-pointer.ae5111fa2d8450b8d1c1ad3b9056bace.svg";
export { ForwardRef as ReactComponent };